exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pager{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pager__nav{display:inline-block;margin:2px 4px;cursor:pointer}.pager__nav--current{cursor:default}.pager-amount__select{margin:0 10px;display:inline-block}.pager__nav--first{margin-left:0}.pager__nav--last{margin-right:0}.pager__nav--next{margin-left:15px}.pager__nav--prev{margin-right:15px}", ""]);

// exports
